export default {
  infoBox: {
    currentAccountType: 'Current Account Type',
    subscribeNow: 'Subscribe Now',
    getStarted: 'Get Started',
  },
  pricing: {
    title: 'Pricing & Plans',
    subtitle1: 'Start today, cancel anytime.',
    freeTrial: 'Start Free Now',
    upgradeNow: 'Upgrade Now',
    goBack: 'Maybe Later',
    okayGotIt: 'Okay, got it',
    payMonthly: 'Monthly',
    payAnnually: 'Annual',
    save: '<1> (Save {{discountPercentage}}%)</1>',
    includes: 'Includes',
    mostPopular: 'Most Popular',
    showAllFeatures: 'Show all features',
    hideAllFeatures: 'Hide all features',
  },
  planDescription: {
    personal:
      'For creators who share, monetize and release music across multiple channels.',
    pro: 'For power users and professionals who need a commercial license.',
    free: `For individuals looking to explore 
Loudly's AI music platform.`,
  },
  planShortDescription: {
    personal: 'For creators.',
    pro: 'For power users.',
    free: 'For individuals.',
  },
  priceTag: {
    monthly: 'month',
    year: 'year',
    save: 'Save',
    discountedPrice: `$<1>{{discountedPrice}}</1> - `,
    saveAnnually: '<1> Save {{discountPercentage}}%</1>',
    noCreditCardRequired: 'No credit card required',
    billedMonthly: 'Billed monthly',
    billedAnnually: 'Billed annually',
    custom: 'Custom',
    savePercent: 'Save up to {{percentage}}% by paying annually',
  },
  priceFeatures: {
    catalog: 'Pre-cleared music catalog for YouTube and all social media',
    song: '100+ new song templates every month',
    payment: 'Secure payment with stripe in any country',
  },

  success: {
    title: 'Success!',
    message: {
      1: 'Thanks for your payment, your subscription has been activated.',
    },
    action: 'Continue',
    continue: 'Continue',
  },
};
